import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-3 text-primary" }, "Contact", -1)
const _hoisted_6 = { class: "table table-hover" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", null, "E-mail", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", null, "Tel", -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", null, "Fax", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", null, "Address", -1)
const _hoisted_12 = { class: "u-pre-line" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-3 text-primary" }, "Access", -1)
const _hoisted_15 = { class: "embed-responsive embed-responsive-4by3" }
const _hoisted_16 = ["src"]
const _hoisted_17 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _hoisted_7,
                _createElementVNode("td", null, _toDisplayString(_ctx.contact.email), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_8,
                _createElementVNode("td", null, _toDisplayString(_ctx.contact.tel), 1)
              ]),
              (_ctx.contact.fax != '')
                ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("td", null, _toDisplayString(_ctx.contact.fax), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _hoisted_11,
                _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.contact.address), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("iframe", {
              src: _ctx.contact.googlemap,
              width: "400",
              height: "300",
              frameborder: "0",
              style: {"border":"0"},
              "aria-hidden": "false",
              tabindex: "0"
            }, null, 8, _hoisted_16)
          ]),
          _createElementVNode("p", {
            innerHTML: _ctx.contact.mapnote
          }, null, 8, _hoisted_17)
        ])
      ])
    ])
  ]))
}